export default __webpack_public_path__ + "static/media/EngageLogo.2fefe7d1.svg";